$(document).ready(function() {
  function setupLangInteraction() {
    $('.header__lang').off(); // 移除所有事件
    
    if ($(window).width() <= 960) {
      // 移动端/小屏幕 - 点击事件
      $('.header__lang').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('open-sp');
      });
    } else {
      // 大屏幕 - 悬停事件
      $('.header__lang').hover(
        function() {
          $(this).addClass('open-pc');
        },
        function() {
          $(this).removeClass('open-pc');
        }
      );
    }
  }
  
  // 初始设置
  setupLangInteraction();
  
  // 窗口大小改变时重新设置
  $(window).resize(function() {
    setupLangInteraction();
  });
});